export default {
	state: {
		positionLeft: 0,
		positionTop: 0,
		activePosition: false
	},
	getters: {
		getPositionLeft(state) {
			return state.positionLeft;
		},
		getPositionTop(state) {
			return state.positionTop;
		},
		getPositionActive(state) {
			return state.activePosition;
		}
	},
	mutations: {
		SET_POSITION_LEFT(state, payload) {
			state.positionLeft = payload;
		},
		SET_POSITION_TOP(state, payload) {
			state.positionTop = payload;
		},
		SET_POSITION_ACTIVE(state, payload) {
			state.activePosition = payload;
		}
	},
	actions: {
		setPosition({ commit }, payload) {
			commit('SET_POSITION_LEFT', payload.left);
			commit('SET_POSITION_TOP', payload.top);
			commit('SET_POSITION_ACTIVE', true);
		}
	}

};
